import { gql } from '@apollo/client';

const GET_POOLS = gql`
  query GetPools {
    user {
      id
      company {
        id
        pools {
          id
          last_updated_date
          name
          asset_class
          created_date
          loan_count
          state
          t_current_balance_cents
          wa_coupon_bps
          wa_loan_age_months
          wa_borrower_credit_score
          wa_remaining_loan_terms_months
          wa_ltv_bps
          wa_dti_bps
          has_cra
          is_public
        }
      }
    }
  }
`;

export { GET_POOLS };
